import { useAppDispatch, useAppSelector } from '@hooks/app/redux';
import { EmailOutlined, PasswordOutlined } from '@icon';
import { AuthTitleSC } from '@pages/auth/auth.styled';
import { actions } from '@store/ducks/auth';
import { Button, Form, TextField } from '@ui';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useTheme } from 'styled-components';
import { initialValues, TFormValues, validationSchema } from './login-form.schema';

const LoginForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const error = useAppSelector((store) => store.auth.loginError);
  const loginLoading = useAppSelector((store) => store.auth.loginLoading);

  const onSubmit = (values: TFormValues) => {
    dispatch(actions.getLoginRequest(values));
  };

  React.useEffect(() => {
    return () => {
      dispatch(actions.resetLoginError());
    };
  }, []);

  const [, formOption] = Form.useForm({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return (
    <>
      <AuthTitleSC>
        <FormattedMessage id="login.header" />
      </AuthTitleSC>
      <Form {...formOption} showFeedback={false} showLabel={false}>
        <Form.Field name="email" error={error} label={formatMessage({ id: 'login.email' })}>
          <TextField
            type="email"
            autoComplete="email"
            placeholder={`${formatMessage({ id: 'login.email' })}*`}
            left={<TextField.Icon Icon={EmailOutlined} />}
          />
        </Form.Field>
        <Form.Field name="password" label={formatMessage({ id: 'login.password' })}>
          <TextField
            placeholder={`${formatMessage({ id: 'login.password' })}*`}
            type="password"
            autoComplete="password"
            left={<TextField.Icon Icon={PasswordOutlined} />}
          />
        </Form.Field>
        <Button
          type="submit"
          loading={loginLoading}
          style={{ marginTop: theme.spacings.component.XS, marginBottom: theme.spacings.text.XS }}
        >
          {formatMessage({ id: 'login.submit' })}
        </Button>
      </Form>
    </>
  );
};

export default LoginForm;
